var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.getLinkUrl,"target":"_blank"}},[_c('img',{staticStyle:{"width":"100%","max-width":"100%","height":"auto"},attrs:{"src":_vm.getPreviewUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }